export default __webpack_public_path__ + "static/media/ic_medium.f6051b2e.svg";